// FoodXHome.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLocationDot,
  faUtensils,
  faDrumstickBite,
  faLeaf,
  faFire,
  faBowlRice,
  faPlay,
  faVolumeUp,
  faVolumeMute,
  faPhone,
  faMessage,
  faStore,
  faCircleDot,
  faClock
} from '@fortawesome/free-solid-svg-icons';

const dummyFoodZones = ["400001", "400002", "400003", "Dadar", "Bandra", "Andheri", "Ghatkopar"];

const dummyCategories = [
  { id: "north", name: "North Indian", emoji: "🍛", icon: faUtensils },
  { id: "south", name: "South Indian", emoji: "🥘", icon: faLeaf },
  { id: "chinese", name: "Chinese", emoji: "🥡", icon: faFire },
  { id: "biryani", name: "Biryani", emoji: "🍗", icon: faDrumstickBite },
  { id: "chaat", name: "Chaat", emoji: "🥙", icon: faBowlRice },
  { id: "kebabs", name: "Kebabs", emoji: "🥩" },
  { id: "dosa", name: "Dosa", emoji: "🥞" },
];

const dummyStalls = [
  {
    id: "s1",
    name: "Biryani House Matunga",
    area: "Matunga East",
    pin: "400019",
    live: true,
    lastSeen: null,
    status: "green",
    musicOn: true,
    musicUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    // musicUrl: "https://assets.mixkit.co/music/preview/mixkit-marathi-folk-125.mp3",
    // musicUrl: "https://soundcloud.com/paula28l/new-vs-old-bollywood-songs-mashup-raj-barman-deepshikha-bollywood-songs-medley?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
    offer: "Buy 1 Get 1 Free Chicken Biryani today!",
    signageColor: "#ff6b6b",
    signageFont: "bold",
    category: ["north", "biryani"],
    cameraUrl: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&q=80&w=720&h=1280",
    cameraUrl1: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&q=80&w=720&h=1280",
    cameraUrl2: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&q=80&w=720&h=1280",
    cameraUrl3: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&q=80&w=720&h=1280",
    cameraUrl4: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&q=80&w=720&h=1280",
  },
  {
    id: "s2",
    name: "Shree Dosa Plaza",
    area: "Sion",
    pin: "400022",
    live: true,
    lastSeen: null,
    status: "yellow",
    musicOn: false,
    musicUrl: "https://www.fesliyanstudios.com/play-mp3/1839",
    offer: "Masala Dosa ₹85 only!",
    signageColor: "#4ecdc4",
    signageFont: "medium",
    category: ["south", "dosa"],
    cameraUrl: "https://www.onmycanvas.com/wp-content/uploads/2021/06/triangular-masala-dosa-feature.jpeg",
    cameraUrl1: "https://www.onmycanvas.com/wp-content/uploads/2021/06/triangular-masala-dosa-feature.jpeg",
    cameraUrl2: "https://www.onmycanvas.com/wp-content/uploads/2021/06/triangular-masala-dosa-feature.jpeg",
    cameraUrl3: "https://www.onmycanvas.com/wp-content/uploads/2021/06/triangular-masala-dosa-feature.jpeg",
    cameraUrl4: "https://www.onmycanvas.com/wp-content/uploads/2021/06/triangular-masala-dosa-feature.jpeg",            
  },
  {
    id: "s3",
    name: "Chaat Corner",
    area: "Ghatkopar West",
    pin: "400086",
    live: false,
    lastSeen: "10 min ago",
    status: "red",
    musicOn: false,
    musicUrl: null,
    offer: "Pani Puri + Sev Puri combo ₹99",
    signageColor: "#feca57",
    signageFont: "bold",
    category: ["chaat"],
    cameraUrl: null,
  },
  {
    id: "s4",
    name: "Punjabi Rasoi",
    area: "Dadar West",
    pin: "400028",
    live: true,
    status: "green",
    musicOn: true,
    musicUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
    offer: "Dal Makhani + 2 Butter Naan ₹249",
    signageColor: "#ff9f1c",
    signageFont: "bold",
    category: ["north"],
    cameraUrl: "https://images.squarespace-cdn.com/content/v1/5ea3b22556f3d073f3d9cae4/df893ebd-ae67-4539-ac43-6d13b1fa841d/IMG_0993.JPG",
    cameraUrl1: "https://images.squarespace-cdn.com/content/v1/5ea3b22556f3d073f3d9cae4/df893ebd-ae67-4539-ac43-6d13b1fa841d/IMG_0993.JPG",
    cameraUrl2: "https://images.squarespace-cdn.com/content/v1/5ea3b22556f3d073f3d9cae4/df893ebd-ae67-4539-ac43-6d13b1fa841d/IMG_0993.JPG",
    cameraUrl3: "https://images.squarespace-cdn.com/content/v1/5ea3b22556f3d073f3d9cae4/df893ebd-ae67-4539-ac43-6d13b1fa841d/IMG_0993.JPG",
    cameraUrl4: "https://images.squarespace-cdn.com/content/v1/5ea3b22556f3d073f3d9cae4/df893ebd-ae67-4539-ac43-6d13b1fa841d/IMG_0993.JPG",
  },
];


const FoodXHome = () => {
  const [foodZone, setFoodZone] = useState(() => {
    return localStorage.getItem("foodx_zone") || "";
  });
  const [showZoneSelector, setShowZoneSelector] = useState(!localStorage.getItem("foodx_zone"));
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStall, setSelectedStall] = useState(null);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const audioRef = useRef(null);  

  const toggleSound = () => {
  const audio = audioRef.current;
    if (!audio) return;

    if (audio.paused) {
        // User-initiated play
        audio.play().catch((err) => {
        console.warn("Audio blocked by browser:", err);
        });
        audio.muted = false; // unmute on first tap
        setSoundEnabled(true);
    } else {
        // Pause if already playing
        audio.pause();
        setSoundEnabled(false);
    }
  };

  useEffect(() => {
    if (foodZone) {
      localStorage.setItem("foodx_zone", foodZone);
    }
  }, [foodZone]);

  const filteredStalls = selectedCategory
    ? dummyStalls.filter(stall => stall.category.includes(selectedCategory))
    : dummyStalls;

  const handleZoneSelect = (zone) => {
    setFoodZone(zone);
    setShowZoneSelector(false);
  };

  const handleChangeZone = () => {
    setShowZoneSelector(true);
  };

  const resetSelection = () => {
    setSelectedStall(null);
    setSoundEnabled(false);
  };

  if (showZoneSelector) {
    return (
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
        <div className="text-5xl font-black mb-8 tracking-wider text-orange-500">Food<span className="text-cyan-400">X</span></div>
        
        <h2 className="text-2xl font-bold mb-8 text-center">
          Dekho. Suno. Shuru Ho Jao.
        </h2>

        <div className="w-full max-w-xs space-y-4">
          <p className="text-center text-gray-400 mb-6">Enter your PIN code or Neighbourhood</p>
          
          {dummyFoodZones.map(zone => (
            <button
              key={zone}
              onClick={() => handleZoneSelect(zone)}
              className="w-full py-4 bg-gray-900 hover:bg-gray-800 rounded-xl text-lg font-medium flex items-center justify-center gap-3 border border-gray-700 active:scale-98 transition-transform"
            >
              <FontAwesomeIcon icon={faLocationDot} className="text-cyan-400" />
              {zone}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white pb-20">
      {/* Header */}
      <div className="sticky top-0 z-20 bg-black/80 backdrop-blur-md border-b border-gray-800">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="text-2xl font-black">
            <div>Food<span className="text-cyan-400">X</span></div>
            <div className='text-xs lg:text-lg text-yellow-200  animate-pulse'>Experience Food, Live & Real!</div>
          </div>
          <button
            onClick={handleChangeZone}
            className="flex items-center w-40 gap-2 px-3 py-2 bg-gray-900 rounded-lg text-sm border border-gray-700"
          >
            <FontAwesomeIcon icon={faLocationDot} className="text-orange-400" />
            <span className="font-medium">{foodZone}</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      {selectedStall ? (
        // Stall Detail View - The WOW moment
        <div className="flex flex-col h-[calc(100vh-4rem)]">
          {/* Live Video Area */}
          <div className="relative flex-1 bg-gray-950">
            {selectedStall.live ? (
              <>
                <img
                  src={selectedStall.cameraUrl}
                  alt="Live feed"
                  className="w-full h-1/2 object-cover"
                />
                <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/60 px-3 py-1 rounded-full text-sm">
                  <FontAwesomeIcon icon={faCircleDot} className="text-red-500 animate-pulse" />
                  LIVE
                </div>
              </>
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-900">
                <div className="text-center">
                  <FontAwesomeIcon icon={faClock} className="text-5xl text-gray-600 mb-4" />
                  <p className="text-gray-400">Last seen {selectedStall.lastSeen}</p>
                </div>
              </div>
            )}

            {selectedStall?.live && selectedStall.musicOn && (
            <>
                <audio
                ref={audioRef}
                loop
                preload="auto"           // Changed to auto for faster start (good for demo)
                playsInline              // Important for mobile (prevents full-screen takeover)
                src={selectedStall.musicUrl || ""}  // ← Dynamic! Falls back to empty if null
                />

                <button
                onClick={toggleSound}
                className={`absolute bottom-6 right-6 z-20 w-14 h-14 rounded-full 
                            flex items-center justify-center text-2xl transition-all duration-300
                            ${soundEnabled 
                                ? 'bg-cyan-600/30 border-cyan-400/70 shadow-cyan-500/30' 
                                : 'bg-black/70 border-gray-700/80 hover:border-gray-500'}`}
                aria-label={soundEnabled ? "Mute shop ambiance" : "Play shop ambiance"}
                >
                <FontAwesomeIcon 
                    icon={soundEnabled ? faVolumeUp : faVolumeMute}
                    className={soundEnabled ? "text-cyan-300" : "text-gray-400"}
                />
                </button>

                {soundEnabled && (
                <div className="absolute bottom-24 right-8 text-xs text-cyan-300/80 animate-pulse tracking-wide">
                    AMBIENT ON
                </div>
                )}
            </>
            )}            
          </div>

          {/* Stall Info & Actions */}
          <div className="p-5 bg-gradient-to-t from-black via-black/90 to-transparent">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h1 className="text-2xl font-bold">{selectedStall.name}</h1>
                <p className="text-gray-400">{selectedStall.area} • {selectedStall.pin}</p>
              </div>
              {selectedStall.live && (
                <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                  selectedStall.status === 'green' ? 'bg-green-600' :
                  selectedStall.status === 'yellow' ? 'bg-yellow-600' : 'bg-red-600'
                }`}>
                  {selectedStall.status === 'green' ? 'Not Busy' :
                   selectedStall.status === 'yellow' ? 'Moderate' : 'Busy'}
                </div>
              )}
            </div>

            {selectedStall.offer && (
              <div className="mb-6 p-3 bg-gray-900/80 rounded-xl border border-gray-800">
                <p className="text-orange-300 font-medium">{selectedStall.offer}</p>
              </div>
            )}

            <div className="grid grid-cols-3 gap-4">
              <a
                href={`tel:+919876543210`}
                className="flex flex-col items-center gap-2 py-4 bg-gray-900 rounded-xl border border-gray-800 active:scale-95 transition-transform"
              >
                <FontAwesomeIcon icon={faPhone} className="text-2xl text-green-400" />
                <span className="text-sm">Call</span>
              </a>

              <a
                href={`https://wa.me/919876543210?text=Hello%20from%20FoodX...`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-2 py-4 bg-gray-900 rounded-xl border border-gray-800 active:scale-95 transition-transform"
              >
                <FontAwesomeIcon icon={faMessage} className="text-2xl text-green-500" />
                <span className="text-sm">WhatsApp</span>
              </a>

              <button
                onClick={resetSelection}
                className="flex flex-col items-center gap-2 py-4 bg-gray-900 rounded-xl border border-gray-800 active:scale-95 transition-transform"
              >
                <FontAwesomeIcon icon={faStore} className="text-2xl text-cyan-400" />
                <span className="text-sm">Back</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        // Discovery View
        <div className="px-4 pt-4">
          {/* Category Horizontal Scroll */}
          <div className="mb-4">
            <h2 className="text-lg lg:text-xl font-bold mb-4 text-white flex items-center gap-2">
              <FontAwesomeIcon icon={faUtensils} className="text-orange-400" />
              Explore Food
            </h2>

            <div className="grid grid-cols-2 lg:grid-cols-6 gap-2 place-items-center">
              <button
                onClick={() => setSelectedCategory(null)}
                className={`flex-shrink-0 w-40 px-1 py-1 rounded-md font-medium whitespace-nowrap ${
                  !selectedCategory
                    ? 'bg-cyan-600 text-white text-xs lg:text-sm'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700 text-xs lg:text-sm'
                }`}
              >
                All
              </button>

              {dummyCategories.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => setSelectedCategory(cat.id)}
                  className={`flex-shrink-0 flex items-center gap-2 px-1 py-1 rounded-md font-medium whitespace-nowrap ${
                    selectedCategory === cat.id
                      ? 'bg-cyan-600 text-white text-xs lg:text-sm'
                      : 'bg-gray-800 text-gray-300 hover:bg-gray-700 text-xs lg:text-sm'
                  }`}
                >
                  <span className="text-xl">{cat.emoji}</span>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>

          {/* Stalls Grid */}
          <div className="space-y-5">
            <h2 className="text-lg lg:text-xl text-white font-bold flex items-center gap-2">
              <FontAwesomeIcon icon={faStore} className="text-cyan-400" />
              Live Food Stalls near {foodZone}
            </h2>

            {filteredStalls.length === 0 ? (
              <div className="text-center py-12 text-gray-300">
                No stalls found in this category yet...
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-5">
                {filteredStalls.map(stall => (
                  <div
                    key={stall.id}
                    onClick={() => setSelectedStall(stall)}
                    className="bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 active:scale-[0.98] transition-transform cursor-pointer"
                  >
                    <div className="relative h-52">
                      {stall.live ? (
                        <>
                          <img
                            src={stall.cameraUrl1}
                            alt={stall.name}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute top-3 left-3 flex items-center gap-2 bg-black/70 px-3 py-1 rounded-full text-xs font-medium">
                            <div>
                                <FontAwesomeIcon icon={faCircleDot} className="text-red-500 animate-pulse" />
                                Kitchen
                            </div>
                            <div>
                                <FontAwesomeIcon icon={faCircleDot} className="ml-2 text-red-500 animate-pulse" />
                                Stall
                            </div>
                            <div>
                                <FontAwesomeIcon icon={faCircleDot} className="ml-2 text-red-500 animate-pulse" />
                                Packing
                            </div>
                            <div>
                                <FontAwesomeIcon icon={faCircleDot} className="ml-2 text-red-500 animate-pulse" />
                                Table
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                          <p className="text-gray-500">Offline • Last seen {stall.lastSeen}</p>
                        </div>
                      )}

                      <div className={`absolute bottom-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${
                        stall.status === 'green' ? 'bg-green-600' :
                        stall.status === 'yellow' ? 'bg-yellow-600' : 'bg-red-600'
                      }`}>
                        {stall.status === 'green' ? 'Smooth' : stall.status === 'yellow' ? 'Moderate' : 'Busy'}
                      </div>
                    </div>

                    <div className="p-4">
                      <div className="flex justify-between items-start">
                        <h3 className="font-bold text-lg text-white">{stall.name}</h3>
                        {stall.offer && (
                          <span className="text-xs bg-orange-900/60 text-orange-300 px-2 py-1 rounded">
                            Offer
                          </span>
                        )}
                      </div>
                      <p className="text-gray-400 text-sm mt-1">{stall.area} • {stall.pin}</p>
                      {stall.offer && (
                        <p className="mt-2 text-sm text-orange-300">{stall.offer}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
        <div className="sticky bottom-0 z-20 bg-black/80 backdrop-blur-md mt-2 border-t border-gray-800">
            <div className="flex items-center justify-center px-4 py-3">
                <div className="text-xs lg:text-sm text-yellow-200">(c) 2026 Think5Whys Global DeepTech Solutions</div>
            </div>
        </div>      
    </div>
  );
};

export default FoodXHome;